import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, type RefObject } from "react";
interface UseNearViewportOptions {
  rootMargin?: string;
  /** Reports `true` right away, for content that must not wait for scrolling. */
  skip?: boolean;
}

/**
 * Becomes `true` once the element is within `rootMargin` of the viewport and
 * stays `true`, so content that was loaded is never torn down again.
 */
export function useNearViewport(elementRef, t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    rootMargin: t2,
    skip: t3
  } = t1;
  const rootMargin = t2 === undefined ? "200px" : t2;
  const skip = t3 === undefined ? false : t3;
  const [hasBeenNear, setHasBeenNear] = useState(false);
  let t4;
  let t5;
  if ($[2] !== elementRef || $[3] !== hasBeenNear || $[4] !== rootMargin || $[5] !== skip) {
    t4 = () => {
      const element = elementRef.current;
      if (!element || skip || hasBeenNear) {
        return;
      }
      const observer = new IntersectionObserver(t6 => {
        const [entry] = t6;
        if (entry.isIntersecting) {
          setHasBeenNear(true);
        }
      }, {
        rootMargin
      });
      observer.observe(element);
      return () => observer.disconnect();
    };
    t5 = [elementRef, rootMargin, skip, hasBeenNear];
    $[2] = elementRef;
    $[3] = hasBeenNear;
    $[4] = rootMargin;
    $[5] = skip;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  return skip || hasBeenNear;
}